import { useState } from 'react'
import { ZoomOBFWarningMessage } from './ZoomOBFWarningMessage'
import { ZoomOBFWarningModal } from './ZoomOBFWarningModal'

export interface ZoomOBFWarningProps {
  isTooltip?: boolean
}

export const ZoomOBFWarning: React.FC<ZoomOBFWarningProps> = (props) => {
  const [visible, setVisible] = useState(false)

  return (
    <>
      <ZoomOBFWarningMessage {...props} onReadMore={() => setVisible(true)} />
      {visible ? <ZoomOBFWarningModal show zoomNotConnected onHide={() => setVisible(false)} /> : null}
    </>
  )
}
